var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.35419 13C1.35419 6.56819 6.5682 1.35417 13 1.35417C19.4318 1.35417 24.6459 6.56819 24.6459 13C24.6459 19.4318 19.4318 24.6458 13 24.6458C6.5682 24.6458 1.35419 19.4318 1.35419 13Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0491 8.24409C13.5575 8.494 14.174 8.87346 14.9291 9.33818L15.0007 9.3822C15.7565 9.84736 16.3729 10.2267 16.8294 10.5705C17.293 10.9196 17.6948 11.3052 17.9105 11.8216C18.2243 12.5728 18.2243 13.4272 17.9105 14.1784C17.6948 14.6949 17.293 15.0804 16.8294 15.4295C16.3729 15.7733 15.7565 16.1526 15.0007 16.6178L14.9291 16.6618C14.174 17.1266 13.5575 17.506 13.0491 17.7559C12.5383 18.007 12.0064 18.1964 11.4466 18.1337C10.6374 18.0431 9.91904 17.5925 9.45975 16.9187C9.14804 16.4613 9.03894 15.9063 8.98813 15.316C8.93748 14.7275 8.93749 13.9732 8.9375 13.0389V12.9611C8.93749 12.0268 8.93748 11.2726 8.98813 10.684C9.03894 10.0938 9.14804 9.53868 9.45975 9.08135C9.91904 8.40749 10.6374 7.95694 11.4466 7.86628C12.0064 7.80356 12.5383 7.99297 13.0491 8.24409ZM11.6275 9.48118C11.7125 9.47165 11.896 9.48795 12.3322 9.70241C12.7628 9.9141 13.3135 10.252 14.1136 10.7444C14.9134 11.2366 15.4637 11.5763 15.8518 11.8686C16.2401 12.161 16.3631 12.333 16.4111 12.4479C16.5574 12.7983 16.5574 13.2017 16.4111 13.5521C16.3631 13.667 16.2401 13.839 15.8518 14.1314C15.4637 14.4237 14.9134 14.7634 14.1136 15.2556C13.3135 15.748 12.7628 16.0859 12.3322 16.2976C11.896 16.5121 11.7125 16.5284 11.6275 16.5188C11.3117 16.4834 11.0081 16.3051 10.8025 16.0034C10.7331 15.9016 10.6516 15.6934 10.6071 15.1766C10.5632 14.6662 10.5625 13.9823 10.5625 13C10.5625 12.0177 10.5632 11.3338 10.6071 10.8234C10.6516 10.3066 10.7331 10.0984 10.8025 9.99656C11.0081 9.69495 11.3117 9.51656 11.6275 9.48118Z",
    fill: "url(#paint0_linear_56_4686)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_56_4686",
    x1: 13.6192,
    y1: 20.3384,
    x2: 27.7048,
    y2: 7.98441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuVideo);
export default __webpack_public_path__ + "static/media/menu-video.c05f522f235b61efd5e59438ee7f7f1b.svg";
export { ForwardRef as ReactComponent };